"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BackupDialogContent;
var _react = require("react");
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _List = _interopRequireDefault(require("@mui/material/List/List.js"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText/ListItemText.js"));
var _ListItemButton = _interopRequireDefault(require("@mui/material/ListItemButton/ListItemButton.js"));
var _Skeleton = _interopRequireDefault(require("@mui/material/Skeleton/Skeleton.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react2 = require("@ag-grid-community/react");
var _helpers = require("../../utils/helpers");
require("@ag-grid-community/styles/ag-grid.css");
require("@ag-grid-community/styles/ag-theme-alpine.css");
var _moment = _interopRequireDefault(require("moment"));
var _core = require("@ag-grid-community/core");
var _clientSideRowModel = require("@ag-grid-community/client-side-row-model");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
_core.ModuleRegistry.registerModules([_clientSideRowModel.ClientSideRowModelModule]);
const useStyles = (0, _makeStyles.default)(theme => ({
  listItemRoot: {
    '&.Mui-selected': {
      backgroundColor: ' #cccccc'
    }
  }
}));
function BackupDialogContent({
  selectedScheduleList,
  onClickList,
  selectedScheduleItem,
  selectedSchedule
}) {
  // AgGrid Items
  const containerStyle = (0, _react.useMemo)(() => ({
    width: '100%',
    height: '300px',
    display: 'flex',
    alignItems: 'end',
    flexDirection: 'column'
  }), []);
  const VIEW_LAYOUT_RULES = [{
    headerName: 'Step Name',
    field: 'Name',
    tooltip: 'Name'
  }, {
    headerName: 'Start Time',
    field: 'StartedOn',
    wrapText: true,
    autoHeight: true,
    tooltip: 'StartedOn'
  }, {
    headerName: 'End Time',
    field: 'FinishedOn',
    wrapText: true,
    autoHeight: true,
    tooltip: 'FinishedOn'
  }, {
    headerName: 'Status',
    field: 'StatusName',
    tooltip: 'StatusName'
  }];
  const gridStyle = (0, _react.useMemo)(() => ({
    height: '100%',
    width: '100%'
  }), []);
  const gridRef = (0, _react.useRef)(null);
  const defaultColDef = (0, _react.useMemo)(() => {
    return {
      flex: 1,
      minWidth: 100,
      resizable: true,
      sortable: true
    };
  }, []);

  //List States
  const classes = useStyles();
  const handleListItemClick = (event, index) => {
    onClickList(index);
  };
  const RowData = (0, _react.useCallback)(() => {
    if (!selectedScheduleItem) {
      return [];
    } else {
      let selected_sch = selectedScheduleList.find(item => item.Id == selectedScheduleItem);
      return selected_sch?.Steps?.map(item => {
        return {
          ...item,
          StartedOn: (0, _moment.default)(item.StartedOn).format('MM/DD/YYYY hh:mm:ss A'),
          FinishedOn: (0, _moment.default)(item.FinishedOn).format('MM/DD/YYYY hh:mm:ss A'),
          StatusName: _helpers.BackupJobStatus[item.Status]
        };
      });
    }
  }, [selectedScheduleItem]);
  selectedScheduleList = selectedScheduleList.map(item => {
    return {
      ...item,
      StartedOnDate: (0, _moment.default)(item.StartedOn).format('MM/DD/YYYY'),
      StartedOnTime: (0, _moment.default)(item.StartedOn).format('hh:mm:ss A')
    };
  });
  (0, _react.useEffect)(() => {
    if (selectedScheduleList.length > 0) {
      gridRef?.current?.api?.hideOverlay();
    } else {
      gridRef?.current?.api?.showLoadingOverlay();
    }
  }, [selectedScheduleList]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    sx: {
      display: 'flex',
      p: 1
    },
    children: [!selectedSchedule ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      sx: {
        width: '100%',
        maxWidth: '20%'
      }
    }) : selectedScheduleList?.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.default, {
      sx: {
        width: '100%',
        maxWidth: '20%',
        bgcolor: 'background.paper',
        position: 'relative',
        overflow: 'auto',
        maxHeight: 300,
        '& ul': {
          padding: 0
        }
      },
      subheader: /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {}),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
          children: selectedScheduleList.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemButton.default, {
            selected: selectedScheduleItem == item.Id,
            onClick: event => handleListItemClick(event, item.Id),
            classes: {
              root: classes.listItemRoot
            },
            sx: {
              borderBottom: '1px groove'
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
              primary: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
                sx: {
                  fontWeight: 'bold'
                },
                children: item.StartedOnDate
              }),
              secondary: item.StartedOnTime
            })
          }, item.Id))
        })
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      sx: {
        width: '100%',
        maxWidth: '20%'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, {
        animation: "wave",
        height: 65
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, {
        animation: "wave",
        height: 50
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, {
        animation: "wave",
        height: 65
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, {
        animation: "wave",
        height: 50
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, {
        animation: "wave",
        height: 65
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: containerStyle,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        style: gridStyle,
        sx: theme => ({
          '.ag-header-cell-label': {
            justifyContent: 'center'
          },
          '.ag-header-group-cell-label': {
            justifyContent: 'center'
          },
          '.ag-header-group-cell-with-group': {
            backgroundColor: 'lightcyan !important'
          },
          '.ag-header-cell-resize::after': {
            height: '100% !important',
            top: '0 !important'
          },
          '.ag-cell .MuiAutocomplete-root .MuiTextField-root': {
            display: 'inline-block'
          },
          p: 1
        }),
        className: "ag-theme-alpine",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.AgGridReact, {
          ref: gridRef,
          rowData: RowData(),
          columnDefs: VIEW_LAYOUT_RULES,
          defaultColDef: defaultColDef,
          className: "ag-theme-alpine",
          overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Loading...</span>'
        })
      })
    })]
  });
}